"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPrice = exports.setView = exports.setCurrentOptions = exports.setError = exports.setLoading = exports.setState = exports.selectProduct = exports.changeOptionAction = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var options_1 = require("../../../utils/options");
var getViewsByOptions = function (name, options) {
    var stringOptions = (0, options_1.convertOptionsToString)(options);
    return (0, axios_1.default)("/background_urls/".concat(name, ".json?style=teaser&").concat(stringOptions));
};
var getPriceByOptions = function (name, options) {
    var stringOptions = (0, options_1.convertOptionsToStringWithVerticalLine)(options);
    return (0, axios_1.default)("/blank_item_prices/".concat(name, ".json?variant=").concat(stringOptions, "&only_amount=true"));
};
var changeOptionAction = function (newOptionName, newOptionValue) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, singular, options, _b, blank, background, _c, basePrice, currentPrice, error_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, 4, 5]);
                _a = (0, exports.selectProduct)(getState()), singular = _a.singular, options = _a.condition.options;
                options[newOptionName] = newOptionValue;
                dispatch((0, exports.setLoading)(true));
                dispatch((0, exports.setCurrentOptions)(options));
                return [4 /*yield*/, getViewsByOptions(singular, options)];
            case 1:
                _b = (_d.sent()).data, blank = _b.blank, background = _b.background;
                return [4 /*yield*/, getPriceByOptions(singular, options)];
            case 2:
                _c = (_d.sent()).data, basePrice = _c.base_price, currentPrice = _c.current_price;
                dispatch((0, exports.setView)(blank || background));
                dispatch((0, exports.setPrice)({
                    basePrice: basePrice,
                    currentPrice: currentPrice,
                }));
                return [3 /*break*/, 5];
            case 3:
                error_1 = _d.sent();
                dispatch((0, exports.setError)(error_1));
                return [3 /*break*/, 5];
            case 4:
                dispatch((0, exports.setLoading)(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
exports.changeOptionAction = changeOptionAction;
var productSlice = (0, toolkit_1.createSlice)({
    name: 'product',
    initialState: {
        condition: { options: {}, price: {} },
        editorPath: '',
        minPrice: 0,
        name: '',
        options: [],
        popularProducts: [],
        preview: '',
        priceList: '',
        reviews: { counts: 0, path: '', content: [] },
        seo: {
            tabsBlock: [],
            h1Text: null,
            h2Text: null,
            regularTextHtml: null,
            bannerImage: null,
            beforeFooterText: null,
        },
        shortTitle: '',
        singular: '',
        title: '',
        view: '',
        loading: false,
        error: '',
    },
    reducers: {
        setState: function (_, _a) {
            var payload = _a.payload;
            return payload;
        },
        setLoading: function (state, _a) {
            var payload = _a.payload;
            state.loading = payload;
        },
        setCurrentOptions: function (state, _a) {
            var payload = _a.payload;
            state.condition.options = payload;
        },
        setError: function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
        },
        setView: function (state, _a) {
            var payload = _a.payload;
            state.view = payload;
        },
        setPrice: function (state, _a) {
            var payload = _a.payload;
            state.condition.price = payload;
        },
    },
});
var selectProduct = function (state) { return state.product; };
exports.selectProduct = selectProduct;
exports.setState = (_a = productSlice.actions, _a.setState), exports.setLoading = _a.setLoading, exports.setError = _a.setError, exports.setCurrentOptions = _a.setCurrentOptions, exports.setView = _a.setView, exports.setPrice = _a.setPrice;
exports.default = productSlice.reducer;
